import { Box, Typography, Card, CardContent, Button } from "@mui/material";
import { useNavigate } from "react-router-dom";
import { PDFDownloadLink } from "@react-pdf/renderer";
import CarePlanPDFDocument from "./CarePlanPDFDocument";
import { useTranslation } from "react-i18next";

export default function CarePlanSuccessSummary({ careGoals, patientInfo }) {
  const navigate = useNavigate();
  const { t } = useTranslation();
  return (
    <Box sx={{ p: 4 }}>
      <Typography variant="h4" fontWeight="bold" color="green" sx={{ mb: 2 }}>
        ✅ {t("PatientAssignment.CarePlanSavedSuccessfully")}
      </Typography>
      <Typography variant="body1" sx={{ mb: 4 }}>
        {t("PatientAssignment.Belowisasummary")}:
      </Typography>

      {careGoals.map((goal) => (
        <Card key={goal.caregoalId} sx={{ mb: 3, width: "100%" }}>
          <CardContent>
            <Typography variant="h6" color="primary" fontWeight="bold">
              🎯 {goal.name}
            </Typography>
            <Typography variant="body2" sx={{ mb: 2 }}>{goal.description}</Typography>

            <Typography variant="subtitle2" fontWeight="bold">{t("PatientAssignment.Treatments")}:</Typography>
            {goal.treatments.length === 0 ? (
              <Typography variant="body2" fontStyle="italic">{t("PatientAssignment.Notreatments")}</Typography>
            ) : (
              goal.treatments.map((t, idx) => (
                <Typography key={idx} variant="body2">- {t.treatmentName}</Typography>
              ))
            )}

            <Typography variant="subtitle2" fontWeight="bold" sx={{ mt: 2 }}>{t("PatientAssignment.FollowUps")}:</Typography>
            {goal.followUps.length === 0 ? (
              <Typography variant="body2" fontStyle="italic">{t("PatientAssignment.Nofollowups")}</Typography>
            ) : (
              goal.followUps.map((f, idx) => (
                <Typography key={idx} variant="body2">- {f.followUpName}</Typography>
              ))
            )}
          </CardContent>
        </Card>
      ))}

      <Box mt={4} textAlign="center">
        <Button variant="contained" onClick={() => navigate("/CarePlan")}>
          Back to Care Plan
        </Button>
        <PDFDownloadLink
          document={<CarePlanPDFDocument careGoals={careGoals} patientInfo={patientInfo} />}
          fileName="CarePlanSummary.pdf"
        >
          {({ loading }) =>
            loading ? (
              <Button variant="outlined" disabled>
                Generating PDF...
              </Button>
            ) : (
              <Button variant="contained">📄 Download PDF</Button>
            )
          }
        </PDFDownloadLink>
      </Box>
    </Box>
  );
}
